import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo-camp-original-icone.png'


const _withScopeId = n => (_pushScopeId("data-v-6ef057f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-md-row h-100 w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    alt: "Logo",
    style: {"width":"200px"},
    src: _imports_0
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "d-flex flex-grow-1 w-md-50 h-100 bg-wither" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "d-none d-md-flex flex-grow-1 flex-column flex-column-fluid w-md-50 h-20 h-md-100",
      style: _normalizeStyle(`background-image: url('https://painel.indicar.info/media/logos/mecanicotroca.png'); background-size: cover; background-position: left center;`)
    }, _hoisted_3, 4),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ])
  ]))
}